// packages/editor/src/round-trip/round-trip.ts
//
// §C.1 round-trip contract, evaluated at the mdast layer.
// MDXEditor itself depends on these same mdast utilities, so a passing
// round-trip here means MDXEditor will inherit the property; a failing
// round-trip here is the §D.4 BlockNote re-evaluation trigger.

import type { Root } from 'mdast';
import { fromMarkdown } from 'mdast-util-from-markdown';
import { toMarkdown } from 'mdast-util-to-markdown';
import { directive } from 'micromark-extension-directive';
import {
  directiveFromMarkdown,
  directiveToMarkdown,
} from 'mdast-util-directive';
import { gfm } from 'micromark-extension-gfm';
import { gfmFromMarkdown, gfmToMarkdown } from 'mdast-util-gfm';

export function parseToMdast(md: string): Root {
  return fromMarkdown(md, {
    extensions: [directive(), gfm()],
    mdastExtensions: [directiveFromMarkdown(), gfmFromMarkdown()],
  });
}

export function serializeFromMdast(tree: Root): string {
  return toMarkdown(tree, {
    extensions: [directiveToMarkdown(), gfmToMarkdown()],
  });
}

/** parse → serialize → return new markdown */
export function roundTrip(md: string): string {
  return serializeFromMdast(parseToMdast(md));
}
